import { cx } from "../../Utils/helpers";

/**
 * Abstract gradient placeholder used wherever the brief calls for imagery
 * we don't have a real asset for yet (case studies, knowledge hub).
 * Swap for a real <img> once photography/screenshots are supplied —
 * the calling section only needs to pass a real `src` prop then.
 */
function MediaTile({ icon, tone = "blue", ratio = "16/10", className, children }) {
  return (
    <div className={cx("media-tile", `media-tile--${tone}`, className)} style={{ aspectRatio: ratio }}>
      <span className="media-tile__pattern" aria-hidden="true" />
      {icon && <span className="media-tile__icon">{icon}</span>}
      {children}
    </div>
  );
}

export default MediaTile;
